<template>
  <v-app>
    <div
        :class="{'collapsed' : collapsed, 'onmobile' : isOnMobile, 'not-logged-in': !isAuthenticated || !organizationsLoaded || selectedOrganization.IsSubscriptionExpired || !hasActiveOrganization}"
        :style="{'--primary':  primaryColor, '--secondary':  secondaryColor}"
        class="main fill-height secondary">
      <v-main class="fill-height  secondary">
        <div class=" fill-height"
             :class="isAuthenticated && !selectedOrganization.IsSubscriptionExpired && hasActiveOrganization && organizationsLoaded ? 'shadow-inset': 'shadow-inset-top'">
          <v-container v-if="!isAuthenticated || organizationsLoaded"
                       class="fill-height rounded-lg mx-0 d-block route-container" fluid>
            <router-view/>
          </v-container>
        </div>
      </v-main>
      <SidebarMenu
          v-if="isAuthenticated && !selectedOrganization.IsSubscriptionExpired && hasActiveOrganization && organizationsLoaded"
          :collapsed="collapsed"
          :menu="items"
          :theme="isDark ? '': 'white-theme'"
          class="secondary"
          width="270px"
          @toggle-collapse="onToggleCollapse">
        
        <template v-slot:header>
          <div class="header d-flex justify-center">
           
            <v-img :src="require('@/assets/icons/favicon.png')" contain max-width="30"/>
          </div>
        </template>
        <template v-slot:toggle-icon>
          <v-icon v-if="collapsed">mdi-chevron-double-right</v-icon>
          <v-icon v-else>mdi-chevron-double-left</v-icon>
        </template>
      </SidebarMenu>
      <Header/>
      <div
          v-if="isOnMobile && !collapsed"
          class="sidebar-overlay"
          @click="collapsed = true"/>
    </div>
    <NotificationList/>
    <OrganizationSelector/>
    <LoaderOverlay/>
  </v-app>
</template>

<script>

import NotificationList from "@/components/Notification/NotificationList";
import Header from "@/components/Header/Header";
import {SidebarMenu} from 'vue-sidebar-menu';
import OrganizationSelector from "@/components/OrganizationSelector/OrganizationSelector";
import LoaderOverlay from "@/components/reusable/LoaderOverlay/LoaderOverlay";

export default {
  name: 'App',
  components: {LoaderOverlay, OrganizationSelector, Header, NotificationList, SidebarMenu},
  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.getUserCountry();
  },
  data() {
    return {
      collapsed: false,
      isOnMobile: false,
    };
  },
  watch: {
    selectedOrganization: {
      handler() {
        if (this.selectedOrganization.BackgroundColor) {
          this.$vuetify.theme.themes.light.accent = this.selectedOrganization.BackgroundColor;
          this.$vuetify.theme.themes.dark.accent = this.selectedOrganization.BackgroundColor;
        } else {
          this.$vuetify.theme.themes.light.accent = '#9e0d01';
          this.$vuetify.theme.themes.dark.accent = '#9e0d01';
        }
        if (this.selectedOrganization.Color) {
          this.$vuetify.theme.themes.light.accentText = this.selectedOrganization.Color;
          this.$vuetify.theme.themes.dark.accentText = this.selectedOrganization.Color;
        } else {
          this.$vuetify.theme.themes.light.accentText = '#FFFFFF';
          this.$vuetify.theme.themes.dark.accentText = '#FFFFFF';
        }
        this.getUnreadNotificationsAndAlerts(true);
      },
      deep: true
    },
    isAuthenticated(authenticated) {
      if (authenticated) {
        this.getUnreadNotificationsAndAlerts(true);
      }
    }
  },
  computed: {
    primaryColor() {
      return this.isDark ? this.$vuetify.theme.themes.dark.primary : this.$vuetify.theme.themes.light.primary
    },
    secondaryColor() {
      return this.isDark ? this.$vuetify.theme.themes.dark.secondary : this.$vuetify.theme.themes.light.secondary
    },
    selectedOrganization() {
      return this.$store.getters.selectedOrganization;
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    },
    isDark() {
      return this.$store.getters.getTheme === 'dark';
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    items() {
      if (this.selectedOrganization.IsSubscriptionExpired) {
        return [];
      }
      let items = [
        {
          title: this.$t('menu.circles'),
          icon: {
            element: 'img',
            class: 'transparent filter-to-inverse-theme',
            attributes: {
              src: require('@/assets/icons/circles.svg')
            }
          },
          alias: [this.getRoutePathFromName('myCircles'), this.getRoutePathFromName('circleEdit'), this.getRoutePathFromName('circleMemberAdd')],
          href: {
            name: 'circleMap'
          },
        },
        {
          title: this.$t('menu.zones'),
          icon: {
            element: 'img',
            class: 'transparent filter-to-inverse-theme',
            attributes: {
              src: require('@/assets/icons/zones.svg')
            }
          },
          href: {
            name: 'zoneMap',
          },
          alias: [this.getRoutePathFromName('myZones'), this.getRoutePathFromName('addZone'), this.getRoutePathFromName('editZone'), this.getRoutePathFromName('zoneManagement'), this.getRoutePathFromName('geofenceHistory')]
        }];
      if (this.isAdmin) {
        items = [...items, {
          title: this.$t('notifications.users'),
          icon: {
            element: 'img',
            class: 'transparent filter-to-inverse-theme',
            attributes: {
              src: require('@/assets/icons/users.svg')
            }
          },
          href: {
            name: 'users',
          },
          alias: [this.getRoutePathFromName('locationHistory')],
        }];
      }
      items = [...items, {
        title: this.$t('menu.notifications'),
        icon: {
          element: 'img',
          class: 'transparent filter-to-inverse-theme',
          badge: true,
          attributes: {
            src: require('@/assets/icons/notifications.svg')
          }
        },
        class: this.$store.getters.hasUnreadNotifications ? 'badge' : '',
        href: {
          name: this.isAdmin ? 'sendNotifications' : 'notificationHistory'
        },
        alias: [this.getRoutePathFromName('notificationHistory')],
      }, {
        title: this.$t('menu.alerts'),
        icon: {
          element: 'img',
          badge: true,
          class: 'transparent filter-to-inverse-theme',
          attributes: {
            src: require('@/assets/icons/alerts.svg')
          }
        },
        class: this.$store.getters.hasUnreadAlerts ? 'badge' : '',
        href: {
          name: 'alertHistory'
        },
        alias: [this.getRoutePathFromName('scheduledAlerts')],
      }];
      return items;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    hasActiveOrganization() {
      return this.$store.getters.hasActiveOrganization;
    },
    organizationsLoaded() {
      return this.$store.getters.isOrganizationsLoaded;
    }
  },
  methods: {
    onToggleCollapse(collapsed) {
      this.collapsed = collapsed;
    },
    onResize() {
      if (window.innerWidth <= 767) {
        this.isOnMobile = true;
        this.collapsed = true;
      } else {
        this.isOnMobile = false;
        this.collapsed = false;
      }
    },
    getRoutePathFromName(routeName) {
      const routes = this.$router.getRoutes();
      const route = routes.filter((route) => route.name === routeName);
      return route ? route[0].path : null;
    },
    getUserCountry() {
      this.axios.get('https://ipinfo.io', {
        params: {
          token: '5de16cf6e141bc'
        }
      }).then(({data}) => {
        this.$store.dispatch('setUserCountry', data.country);
      });
    },
    async getUnreadNotificationsAndAlerts(showMessage = false) {
      if (this.organizationID) {
        await this.$store.dispatch('getUnreadAlerts');
        await this.$store.dispatch('getUnreadNotifications');
        if (showMessage) {
          if (this.$store.getters.hasUnreadNotifications) {
            this.$store.dispatch('addNotification', {
              type: 'warning',
              message: this.$t('warnings.unreadNotifications'),
              to: 'notificationHistory'
            });
          }

          if (this.$store.getters.hasUnreadAlerts) {
            this.$store.dispatch('addNotification', {
              type: 'warning',
              message: this.$t('warnings.unreadAlerts'),
              to: 'alertHistory'
            });
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "styles/app";
</style>